import React from 'react';
import { WarningModal, PhoneInput, PersonalDataTab } from 'components';
import { formatPhoneNumber } from '_helpers';
import { IApplicant } from 'components/models';

const ApplicantDraftPhoneModal = ({
    show, onHide, getApplicantByPhone, onPush, examId, applicantDetail,
}: IProps) => {
    const [applicantPhone, setApplicantPhone] = React.useState('');
    const [applicantPhoneValid, setApplicantPhoneValid] = React.useState(true);
    const [applicantPhoneProcessing, setApplicantPhoneProcessing] = React.useState(false);

    const [showApplicantPhoneInfo, setShowApplicantPhoneInfo] = React.useState(false);

    const onAddApplicantModal = () => {
        onHide();
        setApplicantPhone('');
    };

    const onChangeApplicantPhone = (name: string, value: string) => {
        setApplicantPhone(value);
        setApplicantPhoneValid(true);
    };

    const onSubmitApplicantModal = async () => {
        if (applicantPhone.length !== 10) {
            setApplicantPhoneValid(false);
        } else {
            setApplicantPhoneProcessing(true);
            const res = await getApplicantByPhone(applicantPhone);
            setApplicantPhoneProcessing(false);

            if (res) {
                setShowApplicantPhoneInfo(true);
            } else if (applicantPhone && examId) {
                onPush(`/exam-draft?applicant-phone=${applicantPhone}&examId=${examId}&from=exam-list`);
            }
        }
    };

    const onHideApplicantPhoneInfoModal = () => {
        setApplicantPhone('');
        setShowApplicantPhoneInfo(false);
    };

    const onSubmitApplicantPhoneInfoModal = async () => {
        if (applicantDetail) {
            onPush(`/exam-draft?applicantId=${applicantDetail.id}${examId ? `&examId=${examId}&` : '&'}from=exam-list`);
        }
    };

    return (
        <>
            <WarningModal
              title="Укажите номер телефона соискателя"
              accessBtnTittle="Продолжить"
              closeBtnTittle="Отмена"
              bodyClassNames="pb-0"
              show={show}
              onHide={onAddApplicantModal}
              onAccess={onSubmitApplicantModal}
              loading={applicantPhoneProcessing}
              withoutTitleMargin
            >
                <section>
                    <div className="mb-4">
                        <span className="d-block">Пожалуйста, укажите номер мобильного телефона соискателя.</span>
                        <span className="d-block">Данный номер телефона должен будет использоваться соискателем при прохождении экзамена.</span>
                    </div>
                    <PhoneInput
                      value={applicantPhone}
                      onChange={onChangeApplicantPhone}
                      inputClassNames="p-0"
                      inputGroupClassNames="pt-2"
                      inputColSize={6}
                      fieldFailures={{ phone: applicantPhoneValid ? '' : 'Некорректный номер' }}
                      withoutLabel
                      autoFocus
                    />
                </section>
            </WarningModal>
            <WarningModal
              title="Проверьте данные соискателя"
              accessBtnTittle="Все верно, продолжить"
              closeBtnTittle="Отмена"
              bodyClassNames="pb-0"
              show={showApplicantPhoneInfo}
              onHide={onHideApplicantPhoneInfoModal}
              onAccess={onSubmitApplicantPhoneInfoModal}
              withoutTitleMargin
            >
                <section>
                    <span className="d-block mb-5">По номеру телефона {formatPhoneNumber(applicantPhone)} зарегистрирован соискатель со следующими данными:</span>
                    <PersonalDataTab
                      personalData={applicantDetail}
                      cardCategory={null}
                      cardTitle={null}
                      withoutPadding
                      withoutEmail
                      withoutPhone
                      withoutRegion
                    />
                </section>
            </WarningModal>
        </>
    );
};

export default ApplicantDraftPhoneModal;

interface IProps {
    show: boolean;
    applicantDetail: IApplicant | null;
    examId?: string | null;
    onHide: () => void;
    onPush: (url: string) => void;
    getApplicantByPhone: (phone: string) => Promise<IApplicant | null>;
}
